import "core-js/modules/es.array.push.js";
import DcModal from '../../../ui/modal/DcModal.vue';
import LoadingDots from '@/dow-platform/components/commerce/shared/loading-dots/index.js';
import { ChevronIcon } from '../../blocks/svg-elements/chevron-icon';
import PoSummaryItem from './po-summary-item.vue';
export default {
  name: 'CheckoutSummary',
  props: {
    checkoutData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      showCancelCheckoutModal: false
    };
  },
  components: {
    DcModal,
    LoadingDots,
    ChevronIcon,
    PoSummaryItem
  },
  computed: {
    isIndia: function () {
      return this.checkoutData?.isIndia;
    },
    isExchangeMessage: function () {
      return this.checkoutData?.isExchangeMessage;
    },
    totalsByPo: function () {
      const isMultiPO = this.checkoutData?.isMultiPO;
      if (isMultiPO && this.checkoutData?.totalsByPo) {
        return this.checkoutData.totalsByPo.map(po => ({
          poNumber: po.poNumber,
          totalsByCurrency: po.totalsByPoList.map(currencyType => ({
            currency: currencyType.currency,
            subtotal: currencyType.totalsByCurrency.checkoutSubtotalAmountFormatted,
            discount: currencyType.totalsByCurrency.discountAmount ? currencyType.totalsByCurrency.discountAmountFormatted : undefined,
            surcharge: currencyType.totalsByCurrency.surchargeAmount ? currencyType.totalsByCurrency.surchargeAmountFormatted : undefined,
            tax: currencyType.totalsByCurrency.taxAmountFormatted,
            total: currencyType.totalsByCurrency.totalAmountFormatted,
            fee: currencyType.totalsByCurrency.feeAmountFormatted
          })),
          expanded: false
        }));
      } else if (!isMultiPO && this.checkoutData?.totalsByCurrencies) {
        return [{
          poNumber: this.checkoutData.poNumberForOrder,
          totalsByCurrency: this.checkoutData.totalsByCurrencies.map(currencyType => ({
            currency: currencyType.currency,
            subtotal: currencyType.subtotalAmountFormatted,
            discount: currencyType.discountAmmount ? currencyType.discountAmountFormatted : undefined,
            surcharge: currencyType.surchargeAmount ? currencyType.surchargeAmountFormatted : undefined,
            tax: currencyType.taxAmountFormatted,
            total: currencyType.totalAmountFormatted,
            fee: currencyType.feeAmountFormatted
          })),
          expanded: true
        }];
      }
      return [];
    }
  },
  methods: {
    getLabel: function (key) {
      return window.Granite.I18n.get(key);
    },
    completeCheckout() {},
    toggleCancelCheckoutModal() {
      this.showCancelCheckoutModal = !this.showCancelCheckoutModal;
    },
    returnToCart() {
      this.toggleCancelCheckoutModal();
      this.$router.push({
        name: 'cart'
      });
    },
    resetDropdowns(poNumber) {
      this.$refs.PoItems.forEach(poItem => {
        if (poItem.poNumber == poNumber || poItem.isExpanded) {
          poItem.toggleIsExpanded();
        }
      });
    }
  }
};